import { fetchAll, fetchFiltered, add, edit, show } from '@/api/commandtypes'
import { t } from '@/lib/i18n'

const state = {
  all: [],
  isLoading: false,
  commandTypeById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const commandTypes = await fetchAll()
      commit('setAll', commandTypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const commandType = await show(id)
      commit('setCommandTypeById', commandType)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const commandTypes = await fetchFiltered(queriesParams)
      commit('setAll', commandTypes)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', { message: t(e.message) + ' já cadastrado!' || e }, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, { commandType, sendOs }) {
    commit('setLoading', true)
    try {
      await add(commandType)
      return true
    } catch (e) {
      if (!sendOs) dispatch('notify/error', { message: t(e.message) + ' já cadastrado!' || e }, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  setAll (state, commandTypes) {
    state.all = commandTypes
  },

  setCommandTypeById (state, commandType) {
    state.commandTypeById = commandType
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },

  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.commandTypeById = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
